app.directive("acOnclickShow", ['$rootScope','NetworkService', function($rootScope, NetworkService) {
    return {
        link: function(scope, element, attributes) {
            element.bind("click", function(event) {
                var views = $(".ac-view");
                var target = attributes.acOnclickShow;
                
                if(scope.ptGui == undefined){
                    scope.ptGui = {
                        views: {}
                    }
                }
                if(scope.ptGui.views[target] == undefined){
                    scope.ptGui.views[target] = {
                        modelData: {}
                    }
                }
                
                var getViewModel = attributes.acViewGetModel;
                if(getViewModel != undefined){
                    if(getViewModel == "this"){
                        var data = attributes.acViewGetModelData;
                        scope.ptGui.views[target].modelData[getViewModel] = JSON.parse(data);
                    }else{
                        var searchJson = JSON.parse(attributes.acSearchJson);
                        NetworkService.callOperation("get", {model:getViewModel, search:searchJson}, function(response){
                            scope.ptGui.views[target].modelData[getViewModel] = response.get("objects");
                        })
                    }
                }
                
                
                var closeAllSubViews = function(){
                    views.each(function(ind, el){
                            $(el).css("display", "none")
                    })
                }
                
                var el = document.createElement("div");
                var currentViewId = $(event.currentTarget).parents(".ac-view").attr("id")
                el.innerHTML = '<i class="material-icons">arrow_back</i>';
                el.setAttribute("class", "ac-faq-switch")
                $(document).find(".ac-faq-switch").remove()
                $("#"+target).prepend(el);
                $(el).on("click", function(el){
                    closeAllSubViews()
                    console.log("#"+currentViewId);
                    $("#"+currentViewId).css("display", "block")
                })
                
                closeAllSubViews()
                $("#"+target).css("display", "block")
            });
        }
    }
}]);